module.exports = __webpack_public_path__ + "img/Flatbed (4).58c02fe1.jpg";